export interface User {
    id: number;
    email: string;
    firstName: string;
    lastName: string;
    fullName: string;
    name: string;
    userLicenseType?: number;
    evidenceTool?: EvidenceTool;
    toolLaunchMode?: ToolLaunchMode;
    sortEntityCommentsAsc: boolean;
    jobTitleKey?: string;
}

export enum USER_LICENSE_TYPE {
    STANDARD = 0,
    EXTENDED = 1,
    AUTOMATION = 2
}

export enum EvidenceTool {
    RECORDER_2_0 = 'RECORDER_2_0',
    VIDEO_RECORDER = 'VIDEO_RECORDER',
    LOCOTA = 'LOCOTA',
    SYSTEM_DEFAULT = 'SYSTEM_DEFAULT'
}

export enum ToolLaunchMode {
    ACCOUNT_DEFAULT = 'ACCOUNT_DEFAULT',
    ONLINE = 'ONLINE',
    LOCAL_INSTALLATION = 'LOCAL_INSTALLATION'
}

// Legacy enum - deprecated, kept for backward compatibility during migration
export enum RecordMode {
    ACCOUNT_DEFAULT = 'ACCOUNT_DEFAULT',
    ONLINE = 'ONLINE',
    OFFLINE = 'OFFLINE',
    VIDEO_RECORDER = 'VIDEO_RECORDER',
    LOCOTA = 'LOCOTA'
}
